var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expand-transition',[(_vm.hasError)?_c('standard-alert',{ref:"errorMessage",attrs:{"type":"error"}},_vm._l((_vm.errorTextList),function(text,index){return _c('p',{key:index,staticClass:"mb-0",class:{
        'mb-2': index !== _vm.errorCount - 1,
      }},[_vm._v(" "+_vm._s(text)+" ")])}),0):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }